import { Role } from '@/core/models/auth.interface';
import { AuthService } from '@/core/services/auth.service';
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

export const roleGuard: CanMatchFn = (route, _segments) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    const allowedRoles = (route.data?.['roles'] as Role[] | undefined) ?? [];

    // No roles declared means no restriction
    if (allowedRoles.length === 0) return true;

    // // User this for Multi roles
    
    // const userRoles = authService.getAccessTokenRoles();

    // // Authorized if user has at least one allowed role
    // if (userRoles.some(role => allowedRoles.includes(role))) {
    //     return true;
    // }

    // >>>>>>>>>>>>>>>>>>> Remove this later
    const role = authService.getAccessTokenRole();

    // Authorized
    if (role && allowedRoles.includes(role)) return true;
    // <<<<<<<<<<<<<<<<<<< Remove this later

    // Force unauthenticated users to login again, preserving the intended URL for redirect after login
    authService.clearTokens();
    return router.createUrlTree(['/auth/login'], { queryParams: { redirect: router.url } });
};
